import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router-dom';
const ProtectedRoute = ({ isAuthenticated }) => {
    return isAuthenticated ? _jsx(Outlet, {}) : _jsx(Navigate, { to: "/", replace: true });
};
export default ProtectedRoute;
